import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken, getToken } from "../lib/api";
import { toast } from "../hooks/use-toast";
import { Lock, ArrowRight } from "lucide-react";

const AdminLogin = () => {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = getToken();
    if (!t) return;
    api.get("/admin/me").then(() => nav("/admin/dashboard", { replace: true })).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      setToken(data.token);
      toast({ title: "Welcome back", description: `Signed in as ${data.username}` });
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast({ title: "Sign in failed", description: err?.response?.data?.detail || "Invalid credentials" });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-[420px] rounded-lg p-8" style={{ background: '#fbf8ef' }}>
        <div className="w-10 h-10 rounded-md flex items-center justify-center mb-4" style={{ background: '#0f3d2e', color: '#f4efe4' }}><Lock size={18} /></div>
        <h1 className="hero-title text-[36px] leading-tight mb-2">Admin <span className="font-serif-i text-[#e0684d]">sign in</span></h1>
        <p className="text-[13px] text-[#0d2a20]/70 mb-6">Protected area. Applications & inquiries.</p>
        <div className="space-y-4">
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Username</label>
            <input required data-testid="admin-username" value={username} onChange={e => setUsername(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Password</label>
            <input required data-testid="admin-password" value={password} onChange={e => setPassword(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <button disabled={loading} data-testid="admin-login-submit" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md btn-coral text-[14px] disabled:opacity-50">{loading ? 'Signing in…' : 'Sign in'} <ArrowRight size={14} /></button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
